
import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import toast from "react-hot-toast";

//API
import ItemService from "../../../services/customer_appCommonService";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch
import {
  getSupplierCategorySelection,
  getSupplierList,
} from "../../../redux/feature/supplier_app/supplierSlice";

//Components
import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import SuccessRegisterModal from "../../../Components/SuccessRegisterModal";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import FileUploadComponent from "../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";

import {
  validateContactNumber,
  validateEmail,
  validateName,
  validateRequired,
  validateTextArea,
  validPostalCode,
} from "../../../common/Validations";
import CustomerConstants from "../../../common/CustomerConstants";
import CommonFillter from "../../../Components/Filter/Supplier/SupplierCommonFillter";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
};

const CustomerSelfRegistrationV4 = () => {
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Customer");
  localStorage.setItem("submenu", "Customer List");

  let userInfo = useSelector((state) => state?.user?.data); // User Details from Store

  let selectedCategoryData = useSelector(
    (state) => state?.supplier?.selectedCategory
  ); // User Details from Store
  let accountGroupName = useSelector((state) => state?.supplier?.accountGroup); // User Details from Store

  const modalData = {
    title: "Customer Registration",
    successMsg: "",
  };
  let getSoldToPartyTermsofPaymentKey = [
    {
      id: "1",
      name: "TD01 - 1 Day",
    },
    {
      id: "2",
      name: "TD02 - 2 Day",
    },
    {
      id: "3",
      name: "TD03 - 7 Days",
    },
    {
      id: "4",
      name: "TD04 - 30 Days",
    },
    {
      id: "5",
      name: "TD05 - 45 Days",
    },
    {
      id: "6",
      name: "TD06 - 50 Days",
    },
    {
      id: "7",
      name: "TD07 - 33 Days",
    },
    {
      id: "8",
      name: "TD08 - 37 Days",
    },
  ];
  let getSoldTopartyFolioCode = [
    {
      id: "1",
      name: "AAP",
    },
    {
      id: "2",
      name: "ABA",
    },
    {
      id: "3",
      name: "ABG",
    },
    {
      id: "4",
      name: "ABR",
    },
    {
      id: "5",
      name: "ABT",
    },
    {
      id: "6",
      name: "ACM",
    },
    {
      id: "7",
      name: "ACR",
    },
    {
      id: "8",
      name: "ACT",
    },
  ];

  let getTaxClassificationTCSTDS = [
    {
      id: "1",
      name: "TCS",
      code: "TCS Applicable",
      desc: "TCS will be charged on the Invoices",
    },
    {
      id: "2",
      name: "TDS",
      code: "TDS Applicable & Please share the Declaration",
      desc: "TDS will be charged on the Invoices",
    },
  ];
  let getSoldTopartyGrade = [
    {
      id: "1",
      name: "A - GOOD TURNOVER GOOD",
    },
    {
      id: "2",
      name: "CBAA+ - HIGH TURNOVER HIGH",
    },
    {
      id: "3",
      name: "CBAA++ - HIGHER TURNOVER HGHER",
    },
    {
      id: "4",
      name: "CBAA+++ - TOP TURNOVER TOP",
    },
    {
      id: "5",
      name: "CBAB - REASONABLE TURNOVER REASONABLE",
    },
    {
      id: "6",
      name: "CBAC - OTHERS",
    },
  ];
  let getCustomergroup = [
    {
      id: "01",
      name: "Industry",
    },
    {
      id: "02",
      name: "Retail",
    },
    {
      id: "AC",
      name: "AFL CONGS CUST",
    },
    {
      id: "AD",
      name: "AFL DIRECT CUST",
    },
    {
      id: "AG",
      name: "Agent",
    },
    {
      id: "AT",
      name: "Agent",
    },
    {
      id: "AV",
      name: "Arvind Stores",
    },
    {
      id: "BB",
      name: "Big Bazaar",
    },
    {
      id: "BF",
      name: "Brand Factory",
    },
    {
      id: "BM",
      name: "Big Mega Mart",
    },
    {
      id: "C1",
      name: "Priority 1 - Arun",
    },
    {
      id: "C2",
      name: "Priority 2 - Arun",
    },
    {
      id: "C3",
      name: "Priority 3- Arun",
    },
    {
      id: "CA",
      name: "Cons Sales Agent",
    },
  ];

  let getmouLoi = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];
  let getCustomerGroup = [
    {
      id: "1",
      name: "STORE",
    },
    {
      id: "2",
      name: "WAREHOUSE",
    },
  ];
  let getStoreType = [
    {
      id: "1",
      name: "HS",
    },
    {
      id: "2",
      name: "MALL",
    },
  ];
  let getRentalType = [
    {
      id: "1",
      name: "OWNED",
    },
    {
      id: "2",
      name: "LEASE",
    },
  ];
  let getOwnershipType = [
    {
      id: "1",
      name: "OWN STORE",
    },
    {
      id: "2",
      name: "FRANCHISEE STORE",
    },
    {
      id: "3",
      name: "MANAGEMENT FRANCHISEE STORE",
    },
  ];
  let getBrandDivisionAttribute = [
    {
      id: "1",
      name: "BTL",
    },
    {
      id: "2",
      name: "HBD",
    },
    {
      id: "3",
      name: "LBD",
    },
    {
      id: "4",
      name: "UNL",
    },
  ];
  let getstoreCityTire = [
    {
      id: "1",
      name: "Tier I",
    },
    {
      id: "2",
      name: "Tier II",
    },
    {
      id: "3",
      name: "Tier III",
    },
    {
      id: "4",
      name: "Tier IV",
    },
    {
      id: "5",
      name: "Tier V",
    },
  ];
  let getCustodianCheque = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];
  let getSignedCopyReceived = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];
  let getAgreement = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];
  let getBankGurantee = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];
  let getSecurityDeposit = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  // let requiredFields = [];

  const [getDropdownData, setDropdownData] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [data, setData] = useState([]);
  // const [loading, setLoading] = useState(false);
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);
  const [isCardVisible11, setCardVisible11] = useState(true);
  const [isCardVisible12, setCardVisible12] = useState(true);
  const [isCardVisible13, setCardVisible13] = useState(true);
  const [isCardVisible14, setCardVisible14] = useState(true);
  const [isCardVisible15, setCardVisible15] = useState(true);



  const [getCountry, setCountry] = useState([]);
  const [getState, setState] = useState([]);
  const [getTitle, setTitle] = useState([]);
  const [getcontactPosition, setcontactPosition] = useState([]);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);
// eslint-disable-next-line no-unused-vars
  const [getFailureModal, setFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);

  const [getTcsTdsApplicabel, setTcsTdsApplicabel] = useState();
  const [getTcsTdsInvoice, setTcsTdsInvoice] = useState();

  const [hideItem, setHideItem] = useState(false);

  const [validation, setValidation] = useState({
    organisationName: "",
    alternateContactNumber: "",
    alternateEmailId: "",
    purposeJustification: "",
    contactNumber: "",
    email: "",
    cityPostalCode: "",
    address: "",
    address2: "",
    city: "",
    contactfirstName: "",
    contactlastName: "",
    contactPosition: "",
    contactTitle: "",
    ISOCertification: "",
    CompanyBrochure: "",
  });

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };

  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility7 = () => {
    setCardVisible7(!isCardVisible7);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };
  const toggleCardVisibility11 = () => {
    setCardVisible11(!isCardVisible11);
  };
  const toggleCardVisibility12 = () => {
    setCardVisible12(!isCardVisible12);
  };
  const toggleCardVisibility13 = () => {
    setCardVisible13(!isCardVisible13);
  };
  const toggleCardVisibility14 = () => {
    setCardVisible14(!isCardVisible14);
  };
  const toggleCardVisibility15 = () => {
    setCardVisible15(!isCardVisible15);
  };


  const onInputChange = ({ target: { name, type, value, checked } }) => {
    const errors = {};
    setFormInputs((formInputs) => ({
      ...formInputs,
      [name]: type === "checkbox" ? checked : value,
    }));
    validateName(name === "organisationName" ? value : "")
      ? (errors.organisationName = "")
      : (errors.organisationName = message.VALID_CUSTOMER_NAME);
    validateEmail(name === "email" ? value : "")
      ? (errors.email = "")
      : (errors.email = message.VALID_MAIL_ID);
    validateEmail(name === "alternateEmailId" ? value : "")
      ? (errors.alternateEmailId = "")
      : (errors.alternateEmailId = message.VALID_ALTERNATE_MAIL_ID);
    validateContactNumber(name === "contactNumber" ? value : "")
      ? (errors.contactNumber = "")
      : (errors.contactNumber = message.VALID_CONTACT_NUMBER);
    validateContactNumber(name === "alternateContactNumber" ? value : "")
      ? (errors.alternateContactNumber = "")
      : (errors.alternateContactNumber =
          message.VALID_ALTERNATE_CONTACT_NUMBER);
    validateTextArea(name === "purposeJustification" ? value : "")
      ? (errors.purposeJustification = "")
      : (errors.purposeJustification = message.VALID_PURPOSE_JUSTIFICATION);
    validPostalCode(name === "cityPostalCode" ? value : "")
      ? (errors.cityPostalCode = "")
      : (errors.cityPostalCode = message.VALID_POSTAL_CODE);
    validateName(name === "contactfirstName" ? value : "")
      ? (errors.contactfirstName = "")
      : (errors.contactfirstName = message.VALID_CONTACT_FIRST_NAME);
    validateName(name === "contactlastName" ? value : "")
      ? (errors.contactlastName = "")
      : (errors.contactlastName = message.VALID_CONTACT_LAST_NAME);
    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };


  const [formInputs, setFormInputs] = useState({
    customerTypeCode: "C04",
    email: "",
    organisationName: "",
    firstName: "",
    version: "v0",
    status: "Non Invited",
    contactfirstName: "",
    contactlastName: "",
    contactNumber: "",
    category: "VENDOR",
    accountGroup: accountGroupName,
    companyName: "",
    address: "",
    address2: "",
    city: "",
    state: "",
    country: "",
    contactTitle: "",
    cityPostalCode: "",
    ISOCertification: "",
    ICVCertificate: "",
    CompanyBrochure: "",
    CompanyBrochure1: "",
    purposeJustification: "",
    purchaseOrg: "",
    companyCode: "",

    arvindLifestyle: false,
    flyingmachineOptions: false,
    arvindYouthBrands: false,
    interCompany: false,

    consignment: false,
    saleorReturn: false,
    outright: false,
    intercompany: false,
    warehouse: false,

    exclusiveBrandOutlet: false,
    multiBrandOutlet: false,
    keyAccounts: false,
    online: false,
    liquidation: false,
    institutional: false,
    export: false,
    marketplace: false,
    commonChannel: false,

    y007BaseMargin: false,
    y014SpecialMargin: false,
    y003SpecialMargin: false,
    yS60STOMargin: false,
    y003ScaleWise: false,
    y010DealerMargin: false,
    marginNotProvided: false,
    y007Y014Y003Y010YS60: false,
    y003scaleWise: false,
    articleBasedPricing: false,

    uSPolo: false,
    uSPoloFootwear: false,
    arrow: false,
    arrowFootwear: false,
    flyingMachine: false,
    flyingMachineFootwear: false,
    calvinKelvin: false,
    tommyHilfiger: false,

    otherDetails: false,

    multipleBrands: false,
  });
  const [disabled, setDisabled] = useState(false);

  const [getdocumentType, setdocumentType] = useState([]);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [getContactDetails, setContactDetails] = useState([]);
  const contactInfoInitialData = {};

  const [getDocumentTypeData, setDocumentTypeData] = useState([
    {
      id: Date.now(),
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
    },
  ]);

  useEffect(() => {
    dispatch(getSupplierCategorySelection()); // getSupplierCategorySelection store
    getMasterData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    // console.log(">>Check getDropdownData Data", getDropdownData);
    if (getDropdownData?.codeType === "country") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      getStateData(getDropdownData?.code);
    }
    if (getDropdownData?.textCode === "taxClassificationTCSTDSCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      // getStateData(getDropdownData?.code);()
      setTcsTdsApplicabel(getDropdownData?.code);
      setTcsTdsInvoice(getDropdownData?.desc);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  // Datatables
  const fetchUsers = async (page) => {
    setData(selectedCategoryData);
    formInputs.vendorCategory = selectedCategoryData;
  };

  useEffect(() => {
    fetchUsers(1); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategoryData]);

 
  // SAVE
  const handleSave = async () => {
    const requiredFields = [];
    const anyFieldNotEmpty = Object.values(validation).some(
      (value) => value !== null && value !== ""
    );
    if (anyFieldNotEmpty) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }
    if (!validateRequired(formInputs?.organisationName)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        organisationName: message?.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    // if (!validateName(formInputs.organisationName)) {
    //   requiredFields.push(`${message.VALID_SUPPLIER_NAME}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     organisationName: message.VALID_SUPPLIER_NAME,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.address)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     address: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.address2)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     address2: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.city)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     city: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.country)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     country: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.state)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     state: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.cityPostalCode)) {
    //   requiredFields.push(`*${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     cityPostalCode: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validPostalCode(formInputs.cityPostalCode)) {
    //   requiredFields.push(`*${message.VALID_POSTAL_CODE}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     cityPostalCode: message.VALID_POSTAL_CODE,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.contactPosition)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     contactPosition: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.contactTitle)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     contactTitle: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.contactfirstName)) {
    //   requiredFields.push(`*${message.FILL_REQUIRED_FIELD}`);getstoreCityTire
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     contactfirstName: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateName(formInputs.contactfirstName)) {
    //   requiredFields.push(`*${message.VALID_CONTACT_FIRST_NAME}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     contactfirstName: message.VALID_CONTACT_FIRST_NAME,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.contactlastName)) {
    //   requiredFields.push(`*${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     contactlastName: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateName(formInputs.contactlastName)) {
    //   requiredFields.push(`*${message.VALID_CONTACT_LAST_NAME}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     contactlastName: message.VALID_CONTACT_LAST_NAME,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.email)) {
    //   requiredFields.push(`*${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     email: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateEmail(formInputs.email)) {
    //   requiredFields.push(`*${message.VALID_MAIL_ID}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     email: message.VALID_MAIL_ID,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.contactNumber)) {
    //   requiredFields.push(`*${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     contactNumber: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateContactNumber(formInputs.contactNumber)) {
    //   requiredFields.push(`*${message.VALID_CONTACT_NUMBER}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     contactNumber: message.VALID_CONTACT_NUMBER,
    //   }));
    //   return;
    // }
    // if (formInputs.alternateEmailId === formInputs.email) {
    //   requiredFields.push(`*${message.ALTERNATE_MAIL_ID}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     alternateEmailId: message.ALTERNATE_MAIL_ID,
    //   }));
    //   return;
    // }
    // if (formInputs.alternateContactNumber === formInputs.contactNumber) {
    //   requiredFields.push(`*${message.ALTERNATE_CONTACT_NUMBER}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     alternateContactNumber: message.ALTERNATE_CONTACT_NUMBER,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.ISOCertification)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     ISOCertification: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.CompanyBrochure)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     CompanyBrochure: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.customerType)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     customerType: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.purposeJustification)) {
    //   requiredFields.push(`*${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     purposeJustification: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateTextArea(formInputs.purposeJustification)) {
    //   requiredFields.push(`*${message.VALID_PURPOSE_JUSTIFICATION}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     purposeJustification: message.VALID_PURPOSE_JUSTIFICATION,
    //   }));
    //   return;
    // }

    formInputs.firstName = formInputs.organisationName;
    formInputs.documentTypeData = getDocumentTypeData;
    formInputs.contactDetails = getContactDetails;

    formInputs.initiatorName = "Self";
    formInputs.initiator = "Self";

    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });
    let obj = {
      data: formInputs,
    };

    setDisabled(true);
    await ItemService.addSelfCustomer(obj).then((item) => {
      console.log(">> item!", item);
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        // toast.success(item?.message || "Deleted successfully", {
        //   duration: 3000,
        //   position: "top-right",
        // });

        setModalInfo(modalData);
        onSuccessfullyRegistered();
        // Update response value in Redux Store
        dispatch(getSupplierList()); // event store
      } else {
        toast.error("Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);
    setDisabled(false);
  };

  //Load Master Data
  const getMasterData = async () => {
    let obj = {
      codeType: "title",
    };
    await ItemService.getMasterDataSelf(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setTitle(item?.data);
      } else {
        setTitle([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj0 = {
      codeType: "country",
    };
    await ItemService.getMasterDataSelf(obj0).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setCountry(item?.data);
      } else {
        setCountry([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
    
   
    let obj3 = {
      codeType: "jobtitle",
    };
    await ItemService.getMasterDataSelf(obj3).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setcontactPosition(item?.data);
      } else {
        setcontactPosition([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj5 = {
      codeType: "documentType",
    };
    await ItemService.getMasterDataSelf(obj5).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setdocumentType(item?.data);
      } else {
        setdocumentType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  // Onselect of Country state will load
  const getStateData = async (code) => {
    let obj1 = {
      codeType: "region",
      code: code,
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setState(item?.data);
      } else {
        setState([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  const navigateToLogin = () => {
    // navigate(Constants.LOGIN);
    window.history.back();
  };

  const onSuccessUploadFile = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  //Contact start

  const addBankForm = () => {
    setContactDetails([...getContactDetails, contactInfoInitialData]); // Add an empty object to the forms array
  };

  const removeBankForm = (indexToRemove) => {
    setContactDetails(
      getContactDetails.filter((form, index) => index !== indexToRemove)
    );
  };

  useEffect(() => {
    setContactDetails([...getContactDetails, contactInfoInitialData]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeContactInfo = (index, key, value) => {
    if (value) {
      const newForms = [...getContactDetails];
      newForms[index][key] = value;
      setContactDetails(newForms);
    } else {
      // console.log(">> its empty", value);
      setContactDetails((prevState) => {
        const updatedForms = [...prevState];
        updatedForms[index] = {
          ...updatedForms[index],
          [key]: "", // Update the field with the given value (even if empty)
        };
        return updatedForms;
      });
    }
  };
  //contact person end

  /*documetn type  */

  const onSuccessUploadDocumentType = (data) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === data.fieldId
          ? { ...doc, [data.fieldName]: data.attachmentId }
          : doc
      )
    );
  };

  const deleteDocumentType = (id) => {
    const updatedData1 = getDocumentTypeData.filter((doc) => doc.id !== id);
    setDocumentTypeData(updatedData1);
  };
  const addDocumentType = () => {
    const newDocument = {
      id: Date.now(),
      name: `Document ${getDocumentTypeData.length + 1}`,
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
    };
    setDocumentTypeData((prevData) => [...prevData, newDocument]);
  };
  const handleInputChange = (id, fieldName, value) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc
      )
    );
  };

  useEffect(() => {
    const userRole = userInfo?.roles?.[0]?.roleId || null;

    if (userRole === "ADMIN") {
      setHideItem(false);
    } else {
      setHideItem(true);
    }
  }, [userInfo]);
  return (
    <main className="dashboard">
      <Row className="justify-center">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
          
            <Row className="mb-4">
              <Col xs={12} md={2} lg={2} className="text-left">
                <button className="btnBack" onClick={() => navigateToLogin()}>
                  <i className="bi bi-arrow-return-left"></i> Go Back Login
                </button>
              </Col>
              <Col
                xs={12}
                md={{ span: 2, offset: 8 }}
                lg={{ span: 2, offset: 8 }}
                className="text-left"
              >
                <button
                  className="btnTable"
                  onClick={handleSave}
                  disabled={disabled}
                >
                  <i className="bi bi-save"></i> Create
                </button>
              </Col>
            </Row>
            {/* isCardVisible  */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BI</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Primary Data</span>
                      <span className="subHeaderTitle">Primary Details</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Customer Name"
                          extraLabel="As per the trade license"
                          name="organisationName"
                          placeholder=""
                          value={formInputs.organisationName || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation.organisationName}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label=" Address Lines 1 / Street"
                          name="address"
                          placeholder=""
                          value={formInputs.address || ""}
                          onChange={onInputChange}
                          error={validation.address}
                          required={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Address Line 2"
                          name="address2"
                          placeholder=""
                          value={formInputs.address2 || ""}
                          onChange={onInputChange}
                          error={validation.address2}
                          required={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="City"
                          name="city"
                          placeholder=""
                          value={formInputs.city || ""}
                          onChange={onInputChange}
                          error={validation.city}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Country"
                          placeholder=""
                          data={getCountry}
                          id="country"
                          iconClassName="dropdownIcon"
                          name="country"
                          // code="countryCode"
                          // description="countryDesc"
                          setValue={formInputs.country}
                          getvalue={setDropdownData}
                          required={true}
                          error={validation.country}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="State"
                          placeholder=""
                          data={getState}
                          id="state"
                          iconClassName="dropdownIcon"
                          name="state"
                          code="stateCode"
                          description="stateDesc"
                          setValue={formInputs.state}
                          getvalue={setDropdownData}
                          required={true}
                          error={validation.state}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Postal Code/PO Box"
                          name="cityPostalCode"
                          placeholder=""
                          value={formInputs.cityPostalCode || ""}
                          onChange={onInputChange}
                          error={validation.cityPostalCode}
                          required={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Person isCardVisible3 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CP</span>
                    </Col>
                    <Col xs={4} md={9} lg={9}>
                      <span className="headerTitle">Contact Person</span>
                      <span className="subHeaderTitle">
                        Contact Person Details
                      </span>
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <button
                        className="btnTable"
                        onClick={() => addBankForm()}
                        // disabled={getDisabledStatus}
                      >
                        <i className="bi bi-plus-lg "></i> Add Contact Person
                      </button>
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <CommonFillter />
                    </Col>
                  </Row>
                </h2>

                {/* contact  Information */}
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    {/* To Load Dynamic Bank Info Form */}
                    {getContactDetails &&
                      getContactDetails?.map((item, index) => (
                        <div key={index}>
                          <Row className="pt-2 pb-2">
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <h6>Contact Person Section {index + 1}</h6>
                              <span
                                className="deleteIconAccordion"
                                onClick={() => removeBankForm(index)}
                              >
                                {" "}
                                <i className="bi bi-x-circle"></i>{" "}
                              </span>
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Job Title"
                                placeholder=""
                                data={getcontactPosition}
                                id="contactPosition"
                                iconClassName="dropdownIcon"
                                name="contactPosition"
                                setValue={item?.contactPosition || ""}
                                getvalue={setDropdownData}
                                index={index}
                                onChangeValue={handleChangeContactInfo}
                                // disabled={getDisabledStatus}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Contact Title"
                                placeholder=""
                                data={getTitle}
                                id="contactTitle"
                                iconClassName="dropdownIcon"
                                name="contactTitle"
                                setValue={item?.contactTitle || ""}
                                getvalue={setDropdownData}
                                index={index}
                                onChangeValue={handleChangeContactInfo}
                                // disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Contact First Name"
                                name="contactfirstName"
                                placeholder=""
                                value={item?.contactfirstName}
                                onChange={(e) =>
                                  handleChangeContactInfo(
                                    index,
                                    "contactfirstName",
                                    e.target.value
                                  )
                                }
                                // disabled={getDisabledStatus}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Contact Last Name"
                                name="contactlastName"
                                placeholder=""
                                value={item?.contactlastName}
                                onChange={(e) =>
                                  handleChangeContactInfo(
                                    index,
                                    "contactlastName",
                                    e.target.value
                                  )
                                }
                                // disabled={getDisabledStatus}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Contact Email"
                                name="email"
                                placeholder=""
                                value={item?.email}
                                onChange={(e) =>
                                  handleChangeContactInfo(
                                    index,
                                    "email",
                                    e.target.value
                                  )
                                }
                                // disabled={getDisabledStatus}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Contact Number"
                                name="contactNumber"
                                placeholder=""
                                value={item?.contactNumber}
                                onChange={(e) =>
                                  handleChangeContactInfo(
                                    index,
                                    "contactNumber",
                                    e.target.value
                                  )
                                }
                                // disabled={getDisabledStatus}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Alternate Contact Number"
                                name="alternateContactNumber"
                                placeholder=""
                                value={item?.alternateContactNumber}
                                onChange={(e) =>
                                  handleChangeContactInfo(
                                    index,
                                    "alternateContactNumber",
                                    e.target.value
                                  )
                                }
                                // disabled={getDisabledStatus}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Alternate Email-ID"
                                name="alternateEmailId"
                                placeholder=""
                                value={item?.alternateEmailId}
                                onChange={(e) =>
                                  handleChangeContactInfo(
                                    index,
                                    "alternateEmailId",
                                    e.target.value
                                  )
                                }
                                // disabled={getDisabledStatus}
                              />
                            </Col>
                          </Row>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>

            {/* customer Document Type isCardVisible2 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DT</span>
                    </Col>
                    <Col xs={4} md={9} lg={9}>
                      <span className="headerTitle"> Document Type</span>
                      <span className="subHeaderTitle">Document Type</span>
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button className="btnTable" onClick={addDocumentType}>
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Type
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Issue Date
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={1}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          View Files
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Attachments
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex justify-content-center ms-4">
                                          Action
                                        </p>
                                      </Col>
                                    </Row>
                                    {getDocumentTypeData.map((doc, index) => (
                                      <Row key={doc.id}>
                                        <Col xs={12}>
                                          <hr className="mx-4 my-0 text-color-black" />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <ComboboxField
                                            label=""
                                            placeholder="Document type"
                                            data={getdocumentType}
                                            id="documentType"
                                            iconClassName="dropdownIcon"
                                            name="documentType"
                                            code="documentTypeCode"
                                            description="documentTypeDesc"
                                            setValue={doc?.documentType}
                                            getvalue={setDropdownData}
                                            index={doc.id}
                                            onChangeValue={handleInputChange}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Document Number"
                                            value={doc.documentNumber}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "documentNumber",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            type="date"
                                            value={doc.issueDate}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "issueDate",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <div className="d-flex justify-content-center">
                                            {(doc.iSOCertification && (
                                              <img
                                                src="assets/img/newIcons/attached-file.png"
                                                className="mt-1 attachmentIcon"
                                                alt="attachments"
                                                onClick={() =>
                                                  handleViewFile(
                                                    doc.iSOCertification
                                                  )
                                                }
                                              />
                                            )) ||
                                              "--"}
                                          </div>
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <FileUploadComponent
                                            id={doc.id}
                                            name="iSOCertification"
                                            label=""
                                            allowedTypes={[
                                              "image/png",
                                              "image/jpeg",
                                              "application/pdf",
                                            ]}
                                            multiple={true} // Change to `false` for single file selection
                                            required={true}
                                            onSuccessUpload={
                                              onSuccessUploadDocumentType
                                            }
                                            value={doc.iSOCertification || ""}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <i
                                            onClick={() =>
                                              deleteDocumentType(doc.id)
                                            }
                                            className="bi bi-trash text-danger fs-4"
                                          />
                                        </Col>
                                      </Row>
                                    ))}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* mou isCardVisible4 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible5
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">OI</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">MOU/Agreement</span>
                      <span className="subHeaderTitle">
                        MOU/Agreement Details
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible5 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="MOU/LOI"
                          placeholder=""
                          data={getmouLoi}
                          id="mouLoi"
                          iconClassName="dropdownIcon"
                          name="mouLoi"
                          code="countryCode"
                          description="countryDesc"
                          setValue={formInputs?.mouLoi}
                          getvalue={setDropdownData}
                          error={validation?.mouLoi}
                        />
                        {formInputs?.mouLoi === "Yes" && (
                          <Row className="d-flex mt-2">
                            <Col xs={10} md={10} lg={10}>
                              <FileUploadComponent
                                id="mouLoiFile"
                                name="mouLoiFile"
                                label=""
                                allowedTypes={[
                                  "image/png",
                                  "image/jpeg",
                                  "application/pdf",
                                ]}
                                multiple={true} // Change to false for single file selection
                                // required={true}
                                onSuccessUpload={onSuccessUploadFile}
                                value={formInputs?.mouLoiFile || ""}
                              />
                            </Col>
                            <Col xs={2} md={2} lg={2}>
                              {(formInputs?.mouLoiFile && (
                                <img
                                  src="assets/img/newIcons/attached-file.png"
                                  className="mt-1 attachmentIcon"
                                  alt="attachments"
                                  onClick={() =>
                                    handleViewFile(formInputs?.mouLoiFile)
                                  }
                                />
                              )) ||
                                "--"}
                            </Col>
                          </Row>
                        )}
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Custodian Cheque"
                          placeholder=""
                          data={getCustodianCheque}
                          id="custodianCheque"
                          iconClassName="dropdownIcon"
                          name="custodianCheque"
                          code="countryCode"
                          description="countryDesc"
                          setValue={formInputs?.custodianCheque}
                          getvalue={setDropdownData}
                          error={validation?.custodianCheque}
                        />
                        {formInputs?.custodianCheque === "Yes" && (
                          <Row className="d-flex mt-2">
                            <Col xs={10} md={10} lg={10}>
                              <FileUploadComponent
                                id="custodianChequeFile"
                                name="custodianChequeFile"
                                label=""
                                allowedTypes={[
                                  "image/png",
                                  "image/jpeg",
                                  "application/pdf",
                                ]}
                                multiple={true} // Change to false for single file selection
                                // required={true}
                                onSuccessUpload={onSuccessUploadFile}
                                value={formInputs?.custodianChequeFile || ""}
                              />
                            </Col>
                            <Col xs={2} md={2} lg={2}>
                              {(formInputs?.custodianChequeFile && (
                                <img
                                  src="assets/img/newIcons/attached-file.png"
                                  className="mt-1 attachmentIcon"
                                  alt="attachments"
                                  onClick={() =>
                                    handleViewFile(
                                      formInputs?.custodianChequeFile
                                    )
                                  }
                                />
                              )) ||
                                "--"}
                            </Col>
                          </Row>
                        )}
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Signed Copy Received"
                          placeholder=""
                          data={getSignedCopyReceived}
                          id="signedCopyReceived"
                          iconClassName="dropdownIcon"
                          name="signedCopyReceived"
                          code="countryCode"
                          description="countryDesc"
                          setValue={formInputs.signedCopyReceived}
                          getvalue={setDropdownData}
                          error={validation.signedCopyReceived}
                        />
                        {formInputs?.signedCopyReceived === "Yes" && (
                          <Row className="d-flex mt-2">
                            <Col xs={10} md={10} lg={10}>
                              <FileUploadComponent
                                id="signedCopyReceivedFile"
                                name="signedCopyReceivedFile"
                                label=""
                                allowedTypes={[
                                  "image/png",
                                  "image/jpeg",
                                  "application/pdf",
                                ]}
                                multiple={true} // Change to false for single file selection
                                // required={true}
                                onSuccessUpload={onSuccessUploadFile}
                                value={formInputs?.signedCopyReceivedFile || ""}
                              />
                            </Col>

                            <Col xs={2} md={2} lg={2}>
                              {(formInputs?.signedCopyReceivedFile && (
                                <img
                                  src="assets/img/newIcons/attached-file.png"
                                  className="mt-1 attachmentIcon"
                                  alt="attachments"
                                  onClick={() =>
                                    handleViewFile(
                                      formInputs?.signedCopyReceivedFile
                                    )
                                  }
                                />
                              )) ||
                                "--"}
                            </Col>
                          </Row>
                        )}
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Agreement"
                          placeholder=""
                          data={getAgreement}
                          id="agreement"
                          iconClassName="dropdownIcon"
                          name="agreement"
                          code="countryCode"
                          description="countryDesc"
                          setValue={formInputs.agreement}
                          getvalue={setDropdownData}
                          error={validation.agreement}
                        />
                        {formInputs?.agreement === "Yes" && (
                          <Row className="d-flex mt-2">
                            <Col xs={10} md={10} lg={10}>
                              <FileUploadComponent
                                id="agreementFile"
                                name="agreementFile"
                                label=""
                                allowedTypes={[
                                  "image/png",
                                  "image/jpeg",
                                  "application/pdf",
                                ]}
                                multiple={true} // Change to false for single file selection
                                // required={true}
                                onSuccessUpload={onSuccessUploadFile}
                                value={formInputs?.agreementFile || ""}
                              />
                            </Col>
                            <Col xs={2} md={2} lg={2}>
                              {(formInputs?.agreementFile && (
                                <img
                                  src="assets/img/newIcons/attached-file.png"
                                  className="mt-1 attachmentIcon"
                                  alt="attachments"
                                  onClick={() =>
                                    handleViewFile(formInputs?.agreementFile)
                                  }
                                />
                              )) ||
                                "--"}
                            </Col>
                          </Row>
                        )}
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Bank Gurantee"
                          placeholder=""
                          data={getBankGurantee}
                          id="bankGurantee"
                          iconClassName="dropdownIcon"
                          name="bankGurantee"
                          code="countryCode"
                          description="countryDesc"
                          setValue={formInputs?.bankGurantee}
                          getvalue={setDropdownData}
                          error={validation?.bankGurantee}
                        />
                      </Col>
                      {formInputs?.bankGurantee === "Yes" && (
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Bank Gurantee Amt"
                            name="bankGuranteeAmt"
                            placeholder=""
                            value={formInputs?.bankGuranteeAmt || ""}
                            onChange={onInputChange}
                            error={validation?.bankGuranteeAmt}
                          />
                        </Col>
                      )}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Security Deposit"
                          placeholder=""
                          data={getSecurityDeposit}
                          id="securityDeposit"
                          iconClassName="dropdownIcon"
                          name="securityDeposit"
                          code="countryCode"
                          description="countryDesc"
                          setValue={formInputs?.securityDeposit}
                          getvalue={setDropdownData}
                          required={true}
                          error={validation?.securityDeposit}
                        />
                      </Col>
                      {formInputs?.securityDeposit === "Yes" && (
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Security Deposit Amt"
                            name="securityDepositAmt"
                            placeholder=""
                            value={formInputs?.securityDepositAmt || ""}
                            onChange={onInputChange}
                            required={true}
                            error={validation?.securityDepositAmt}
                          />
                        </Col>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {hideItem && (
              <>
                {/* Busniess Model  isCardVisible5*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible7
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility7}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">BM</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Busniess Model</span>
                          <span className="subHeaderTitle">
                            Busniess Model Details
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible7 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer cursor-pointer me-2"
                                htmlFor="consignment"
                              >
                                Consignment (CON){" "}
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="consignment"
                                id="consignment"
                                checked={formInputs?.consignment === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.consignment === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="saleorReturn"
                              >
                                Sale or Return (SOR)
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="saleorReturn"
                                id="saleorReturn"
                                checked={formInputs?.saleorReturn === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.saleorReturn === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>

                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="outright"
                              >
                                Outright (OUT)
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="outright"
                                id="outright"
                                checked={formInputs?.outright === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.outright === true ? "Yes" : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="interCompany"
                              >
                                Inter Company (IC)
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="interCompany"
                                id="interCompany"
                                checked={formInputs?.interCompany === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.interCompany === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="warehouse"
                              >
                                Warehouse (ST)
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="warehouse"
                                id="warehouse"
                                checked={formInputs?.warehouse === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.warehouse === true ? "Yes" : "No"}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* company Code  isCardVisible5*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible6
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility6}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">CC</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Company Code</span>
                          <span className="subHeaderTitle">
                            Code of the Company
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible6 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer cursor-pointer me-2"
                                htmlFor="arvindLifestyle"
                              >
                                Arvind Lifestyle Brands Limited (2100)
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="arvindLifestyle"
                                id="arvindLifestyle"
                                checked={formInputs?.arvindLifestyle === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.arvindLifestyle === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="flyingmachineOptions"
                              >
                                Arvind Fashions Limited (2560)
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="flyingmachineOptions"
                                id="flyingmachineOptions"
                                checked={
                                  formInputs?.flyingmachineOptions === true
                                }
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.flyingmachineOptions === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>

                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="arvindYouthBrands"
                              >
                                Arvind Youth Brands Private Ltd (2500)
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="arvindYouthBrands"
                                id="arvindYouthBrands"
                                checked={formInputs?.arvindYouthBrands === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.arvindYouthBrands === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* channel isCardVisible5*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible8
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility8}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">C</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Channel</span>
                          <span className="subHeaderTitle">
                            Busniess Model Details
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible8 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer cursor-pointer me-2"
                                htmlFor="exclusiveBrandOutlet"
                              >
                                Exclusive Brand Outlet (EB){" "}
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="exclusiveBrandOutlet"
                                id="exclusiveBrandOutlet"
                                checked={
                                  formInputs?.exclusiveBrandOutlet === true
                                }
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.exclusiveBrandOutlet === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="multiBrandOutlet"
                              >
                                Multi Brand Outlet (MB)
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="multiBrandOutlet"
                                id="multiBrandOutlet"
                                checked={formInputs?.multiBrandOutlet === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.multiBrandOutlet === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>

                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="keyAccounts"
                              >
                                Key Accounts (KA)
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="keyAccounts"
                                id="keyAccounts"
                                checked={formInputs?.keyAccounts === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.keyAccounts === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="online"
                              >
                                Online (ON)
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="online"
                                id="online"
                                checked={formInputs?.online === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.online === true ? "Yes" : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="liquidation"
                              >
                                Liquidation (LQ){" "}
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="liquidation"
                                id="liquidation"
                                checked={formInputs?.liquidation === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.liquidation === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="institutional"
                              >
                                Institutional (IN){" "}
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="institutional"
                                id="institutional"
                                checked={formInputs?.institutional === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.institutional === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="export"
                              >
                                Export (EX){" "}
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="export"
                                id="export"
                                checked={formInputs?.export === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.export === true ? "Yes" : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="marketPlace"
                              >
                                Market Place (MI){" "}
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="marketPlace"
                                id="marketPlace"
                                checked={formInputs?.marketPlace === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.marketPlace === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="commonChannel"
                              >
                                Common Channel (CM){" "}
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="commonChannel"
                                id="commonChannel"
                                checked={formInputs?.commonChannel === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.commonChannel === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Margin Details isCardVisible5*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible9
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility9}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">MD</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Margin Details</span>
                          <span className="subHeaderTitle">
                            Margin Details Details
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible9 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer cursor-pointer me-2"
                                htmlFor="y007BaseMargin"
                              >
                                Y007 - Base Margin
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="y007BaseMargin"
                                id="y007BaseMargin"
                                checked={formInputs?.y007BaseMargin === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.y007BaseMargin === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="y014SpecialMargin"
                              >
                                Y014 - Special Margin
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="y014SpecialMargin"
                                id="y014SpecialMargin"
                                checked={formInputs?.y014SpecialMargin === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.y014SpecialMargin === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="y003SpecialMargin"
                              >
                                Y003 - Special Margin (add){" "}
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="y003SpecialMargin"
                                id="y003SpecialMargin"
                                checked={formInputs?.y003SpecialMargin === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.y003SpecialMargin === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="yS60STOMargin"
                              >
                                YS60 - STO Margin{" "}
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="yS60STOMargin"
                                id="yS60STOMargin"
                                checked={formInputs?.yS60STOMargin === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.yS60STOMargin === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="y003ScaleWise"
                              >
                                Y003 - Scale Wise{" "}
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="y003ScaleWise"
                                id="y003ScaleWise"
                                checked={formInputs?.y003ScaleWise === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.y003ScaleWise === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="y010DealerMargin"
                              >
                                Y010 - Dealer Margin{" "}
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="y010DealerMargin"
                                id="y010DealerMargin"
                                checked={formInputs?.y010DealerMargin === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.y010DealerMargin === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="marginNotProvided"
                              >
                                If Margin not Provided, Kindly share the Format
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="marginNotProvided"
                                id="marginNotProvided"
                                checked={formInputs?.marginNotProvided === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.marginNotProvided === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          {formInputs?.marginNotProvided && (
                            <>
                              <Col
                                xs={12}
                                md={3}
                                lg={3}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                <div>
                                  <label
                                    className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                    htmlFor="y007Y014Y003Y010YS60"
                                  >
                                    Y007,Y014,Y003,Y010,YS60
                                  </label>
                                </div>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input custom-switch"
                                    type="checkbox"
                                    role="switch"
                                    name="y007Y014Y003Y010YS60"
                                    id="y007Y014Y003Y010YS60"
                                    checked={
                                      formInputs?.y007Y014Y003Y010YS60 === true
                                    }
                                    onChange={onInputChange}
                                  />
                                  <span>
                                    {formInputs?.y007Y014Y003Y010YS60 === true
                                      ? "Yes"
                                      : "No"}
                                  </span>
                                </div>
                              </Col>
                              <Col
                                xs={12}
                                md={3}
                                lg={3}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                <div>
                                  <label
                                    className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                    htmlFor="y003scaleWise"
                                  >
                                    Y003 - Scale Wise
                                  </label>
                                </div>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input custom-switch"
                                    type="checkbox"
                                    role="switch"
                                    name="y003scaleWise"
                                    id="y003scaleWise"
                                    checked={formInputs?.y003scaleWise === true}
                                    onChange={onInputChange}
                                  />
                                  <span>
                                    {formInputs?.y003scaleWise === true
                                      ? "Yes"
                                      : "No"}
                                  </span>
                                </div>
                              </Col>
                              <Col
                                xs={12}
                                md={3}
                                lg={3}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                <div>
                                  <label
                                    className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                    htmlFor="articleBasedPricing"
                                  >
                                    Article Based Pricing
                                  </label>
                                </div>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input custom-switch"
                                    type="checkbox"
                                    role="switch"
                                    name="articleBasedPricing"
                                    id="articleBasedPricing"
                                    checked={
                                      formInputs?.articleBasedPricing === true
                                    }
                                    onChange={onInputChange}
                                  />
                                  <span>
                                    {formInputs?.articleBasedPricing === true
                                      ? "Yes"
                                      : "No"}
                                  </span>
                                </div>
                              </Col>
                            </>
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Brand Division  isCardVisible5*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible10
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility10}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">BD</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Brand Division</span>
                          <span className="subHeaderTitle">Brand Division</span>
                        </Col>

                        <Col xs={2} md={1} lg={1}>
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible10 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="uSPolo"
                              >
                                U.S. Polo
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="uSPolo"
                                id="uSPolo"
                                checked={formInputs?.uSPolo === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.uSPolo === true ? "Yes" : "No"}
                              </span>
                            </div>
                          </Col>
                          {formInputs?.uSPolo && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="uSPoloFootwear"
                                >
                                  U.S Polo Footwear
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="uSPoloFootwear"
                                  id="uSPoloFootwear"
                                  checked={formInputs?.uSPoloFootwear === true}
                                  onChange={onInputChange}
                                />
                                <span>
                                  {formInputs?.uSPoloFootwear === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </div>
                            </Col>
                          )}

                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="arrow"
                              >
                                Arrow
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="arrow"
                                id="arrow"
                                checked={formInputs?.arrow === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.arrow === true ? "Yes" : "No"}
                              </span>
                            </div>
                          </Col>
                          {formInputs?.arrow && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="arrowFootwear"
                                >
                                  Arrow Footwear
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="arrowFootwear"
                                  id="arrowFootwear"
                                  checked={formInputs?.arrowFootwear === true}
                                  onChange={onInputChange}
                                />
                                <span>
                                  {formInputs?.arrowFootwear === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </div>
                            </Col>
                          )}
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="flyingMachine"
                              >
                                Flying Machine
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="flyingMachine"
                                id="flyingMachine"
                                checked={formInputs?.flyingMachine === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.flyingMachine === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          {formInputs?.flyingMachine && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="flyingMachineFootwear"
                                >
                                  Flying Machine Footwear
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="flyingMachineFootwear"
                                  id="flyingMachineFootwear"
                                  checked={
                                    formInputs?.flyingMachineFootwear === true
                                  }
                                  onChange={onInputChange}
                                />
                                <span>
                                  {formInputs?.flyingMachineFootwear === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </div>
                            </Col>
                          )}
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="calvinKelvin"
                              >
                                Calvin Kelvin
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="calvinKelvin"
                                id="calvinKelvin"
                                checked={formInputs?.calvinKelvin === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.calvinKelvin === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="tommyHilfiger"
                              >
                                Tommy Hilfiger
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="tommyHilfiger"
                                id="tommyHilfiger"
                                checked={formInputs?.tommyHilfiger === true}
                                onChange={onInputChange}
                              />
                              <span>
                                {formInputs?.tommyHilfiger === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Other Details  isCardVisible5*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible11
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility11}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">OD</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Other Details</span>
                          <span className="subHeaderTitle">Other Details</span>
                        </Col>

                        <Col xs={2} md={1} lg={1}>
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible11 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="otherDetails"
                              >
                                Other Details
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="otherDetails"
                                id="otherDetails"
                                checked={formInputs?.otherDetails === true}
                                onChange={onInputChange}
                              />
                            </div>
                          </Col>
                          {formInputs?.otherDetails && (
                            <Row>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Customer group"
                                  placeholder=""
                                  data={getCustomergroup}
                                  id="customergroup"
                                  iconClassName="dropdownIcon"
                                  name="customergroup"
                                  code="countryCode"
                                  description="countryDesc"
                                  setValue={formInputs?.customergroup}
                                  getvalue={setDropdownData}
                                  // required={true}
                                  error={validation.customergroup}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Customer Name"
                                  name="organisationName"
                                  placeholder=""
                                  value={formInputs?.organisationName || ""}
                                  onChange={onInputChange}
                                  // required={true}
                                  error={validation.organisationName}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Delivery Plant"
                                  extraLabel="if blank deliver pant will be considered as 7000 (2100),9000(2560) & 8000 (2500)"
                                  name="deliveryPlant"
                                  placeholder=""
                                  value={formInputs?.deliveryPlant || ""}
                                  onChange={onInputChange}
                                  // required={true}
                                  error={validation.deliveryPlant}
                                />
                              </Col>
                            </Row>
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {(formInputs?.consignment || formInputs?.saleorReturn) && (
                  <>
                    {/* Applicable for SOR/CONSIGNMENT Model isCardVisible5*/}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible5
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility5}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">OD</span>
                            </Col>
                            <Col xs={12} md={9} lg={9}>
                              <span className="headerTitle">
                                Applicable for SOR/CONSIGNMENT Model
                              </span>
                              <span className="subHeaderTitle">
                                Applicable for SOR/CONSIGNMENT Model Details
                              </span>
                            </Col>

                            <Col xs={2} md={1} lg={1}>
                              <CommonFillter />
                            </Col>
                          </Row>
                        </h2>

                        <div
                          className={`accordion-collapse collapse show ${
                            isCardVisible5 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Store City Tire"
                                  placeholder=""
                                  data={getstoreCityTire}
                                  id="storeCityTire"
                                  iconClassName="dropdownIcon"
                                  name="storeCityTire"
                                  // code="storeCityTireCode"
                                  description="countryDesc"
                                  setValue={formInputs?.storeCityTire}
                                  getvalue={setDropdownData}
                                  // required={true}
                                  error={validation.storeCityTire}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding d-flex align-items-center"
                              >
                                <div>
                                  <label
                                    className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                    htmlFor="multipleBrands"
                                  >
                                    Multiple Brands
                                  </label>
                                </div>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input custom-switch"
                                    type="checkbox"
                                    role="switch"
                                    name="multipleBrands"
                                    id="multipleBrands"
                                    checked={
                                      formInputs?.multipleBrands === true
                                    }
                                    onChange={onInputChange}
                                  />
                                  <span>
                                    {formInputs?.multipleBrands === true
                                      ? "Yes"
                                      : "No"}
                                  </span>
                                </div>
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Customer Group"
                                  placeholder=""
                                  data={getCustomerGroup}
                                  id="customerGroup"
                                  iconClassName="dropdownIcon"
                                  name="customerGroup"
                                  // code="customerGroupCode"
                                  // description="customerGroupDesc"
                                  setValue={formInputs?.customerGroup}
                                  getvalue={setDropdownData}
                                  // required={true}
                                  error={validation.customerGroup}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Store Type"
                                  placeholder=""
                                  data={getStoreType}
                                  id="storeType"
                                  iconClassName="dropdownIcon"
                                  name="storeType"
                                  // code="storeTypeCode"
                                  // description="storeTypeDesc"
                                  setValue={formInputs?.storeType}
                                  getvalue={setDropdownData}
                                  // required={true}
                                  error={validation.storeType}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="City Classification"
                                  placeholder=""
                                  data={getStoreType}
                                  id="cityClassification"
                                  iconClassName="dropdownIcon"
                                  name="cityClassification"
                                  // code="cityClassificationCode"
                                  // description="cityClassificationDesc"
                                  setValue={formInputs?.cityClassification}
                                  getvalue={setDropdownData}
                                  // required={true}
                                  error={validation.cityClassification}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Rental Type"
                                  placeholder=""
                                  data={getRentalType}
                                  id="rentalType"
                                  iconClassName="dropdownIcon"
                                  name="rentalType"
                                  // code="rentalTypeCode"
                                  // description="rentalTypeDesc"
                                  setValue={formInputs?.rentalType}
                                  getvalue={setDropdownData}
                                  // required={true}
                                  error={validation.rentalType}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Ownership Type"
                                  placeholder=""
                                  data={getOwnershipType}
                                  id="ownershipType"
                                  iconClassName="dropdownIcon"
                                  name="ownershipType"
                                  // code="ownershipTypeCode"
                                  // description="ownershipTypeDesc"
                                  setValue={formInputs?.ownershipType}
                                  getvalue={setDropdownData}
                                  // required={true}
                                  error={validation.ownershipType}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Brand Division Attribute"
                                  placeholder=""
                                  data={getBrandDivisionAttribute}
                                  id="brandDivisionAttribute"
                                  iconClassName="dropdownIcon"
                                  name="brandDivisionAttribute"
                                  // code="brandDivisionAttributeCode"
                                  // description="brandDivisionAttributeDesc"
                                  setValue={formInputs?.brandDivisionAttribute}
                                  getvalue={setDropdownData}
                                  // required={true}
                                  error={validation.brandDivisionAttribute}
                                />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {/* Sold to Party */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible12
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility12}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">SP</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Sold To Party</span>
                          <span className="subHeaderTitle">
                            Sold To Party Details
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible12 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={12}
                            lg={12}
                            className="commTopButtonRightLeftPadding"
                          >
                            <h5 className="bg-table-status bg-table-new-status mt-3 p-3">
                              Sold-to-Party
                            </h5>
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Title text"
                              name="soldToPartyTitleText"
                              placeholder=""
                              value={formInputs.soldToPartyTitleText || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Name"
                              name="soldToPartyname"
                              placeholder=""
                              value={formInputs.soldToPartyname || ""}
                              onChange={onInputChange}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Street 1"
                              name="soldToPartystreet1"
                              placeholder=""
                              value={formInputs.soldToPartystreet1 || ""}
                              onChange={onInputChange}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Street 2"
                              name="soldToPartystreet2"
                              placeholder=""
                              value={formInputs.soldToPartystreet2 || ""}
                              onChange={onInputChange}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Street 3"
                              placeholder=""
                              // data={getCountry}
                              id="soldToPartystreet3"
                              iconClassName="dropdownIcon"
                              name="soldToPartystreet3"
                              value={formInputs.soldToPartystreet3 || ""}
                              onChange={onInputChange}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Search Term"
                              placeholder=""
                              // data={getState}
                              // id="state"
                              iconClassName="dropdownIcon"
                              name="soldToPartysearchTerm"
                              value={formInputs?.soldToPartysearchTerm || ""}
                              onChange={onInputChange}

                              // getvalue={setDropdownData}
                              // className="dropdownOption"
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Req ID"
                              name="SoldToPartyReqId"
                              placeholder=""
                              value={formInputs?.SoldToPartyReqId || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            {/* <InputField
                          className="inputBox"
                          label="State"
                          name="state"
                          placeholder=""
                          value={formInputs.state || ""}
                          onChange={onInputChange}
                        /> */}
                            <ComboboxField
                              label="Country"
                              placeholder=""
                              data={getCountry}
                              id="soldToPartycountry"
                              iconClassName="dropdownIcon"
                              name="soldToPartycountry"
                              code="soldToPartycountryCode"
                              description="soldToPartycountryDesc"
                              setValue={formInputs.soldToPartycountry}
                              getvalue={setDropdownData}
                              required={true}
                              error={validation.soldToPartycountry}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="State"
                              placeholder=""
                              data={getState}
                              id="soldToPartyState"
                              iconClassName="dropdownIcon"
                              name="soldToPartyState"
                              code="soldToPartyStateCode"
                              description="soldToPartyStateDesc"
                              setValue={formInputs.soldToPartyState}
                              getvalue={setDropdownData}
                              required={true}
                              error={validation.soldToPartyState}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="City"
                              name="SoldToPartyCity"
                              placeholder=""
                              value={formInputs.SoldToPartyCity || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Country"
                          name="country"
                          placeholder=""
                          value={formInputs.country || ""}
                          onChange={onInputChange}
                        />
                      </Col> */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Zip COde"
                              name="soldToPartyZipCode"
                              placeholder=""
                              value={formInputs.soldToPartyZipCode || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Mobile"
                              name="soldToPartyMobile"
                              placeholder=""
                              value={formInputs.soldToPartyMobile || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="TelePhone"
                              name="soldToPartyTelePhone"
                              placeholder=""
                              value={formInputs.soldToPartyTelePhone || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Email"
                              name="soldToPartyEmail"
                              placeholder=""
                              value={formInputs?.soldToPartyEmail || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Terms Of Payment Key"
                                placeholder=""
                                data={getSoldToPartyTermsofPaymentKey}
                                id="soldToPartyTermsofPaymentKey"
                                iconClassName="dropdownIcon"
                                name="soldToPartyTermsofPaymentKey"
                                // code="soldToPartyTermsofPaymentKeyCode"
                                // description="soldToPartyTermsofPaymentKeyDesc"
                                setValue={
                                  formInputs.soldToPartyTermsofPaymentKey
                                }
                                getvalue={setDropdownData}
                                required={true}
                                error={validation.soldToPartyTermsofPaymentKey}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col xs={12} md={5} lg={5}>
                              <h5 className="bg-table-status bg-table-warning-status mt-1">
                                Other Details
                              </h5>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="GSTIN Nr"
                                name="soldToPartyGstinNr"
                                placeholder=""
                                value={formInputs?.soldToPartyGstinNr || ""}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="PAN Nr"
                                name="soldToPartyPanNr"
                                placeholder=""
                                value={formInputs?.soldToPartyPanNr || ""}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Folio Code"
                                placeholder=""
                                data={getSoldTopartyFolioCode}
                                id="soldTopartyGrade"
                                iconClassName="dropdownIcon"
                                name="soldTopartyGrade"
                                code="soldTopartyFolioCodeCode"
                                description="soldTopartyGradeDesc"
                                setValue={formInputs.soldTopartyGrade}
                                getvalue={setDropdownData}
                                // required={true}
                                error={validation.soldTopartyGrade}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Grade"
                                placeholder=""
                                data={getSoldTopartyGrade}
                                id="soldTopartyGrade"
                                iconClassName="dropdownIcon"
                                name="soldTopartyGradeCode"
                                // code="soldTopartyGradeCode"
                                // description="soldTopartyFolioCodeDesc"
                                setValue={formInputs.soldTopartyFolioCode}
                                getvalue={setDropdownData}
                                // required={true}
                                error={validation.soldTopartyFolioCode}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col xs={12} md={5} lg={5}>
                              <h5 className="bg-table-status bg-table-warning-status mt-1">
                                Area Sales Manager
                              </h5>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Area Sales Manager"
                                placeholder=""
                                name="areaSalesManager"
                                value={formInputs.areaSalesManager || ""}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Name"
                                placeholder=""
                                name="areaSalesManagerName"
                                value={formInputs?.areaSalesManagerName || ""}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Mobile Nr"
                                name="areaSalesManagerMobileNr"
                                placeholder=""
                                value={
                                  formInputs?.areaSalesManagerMobileNr || ""
                                }
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Mobile"
                                name="areaSalesManagerMobile"
                                placeholder=""
                                value={formInputs?.areaSalesManagerMobile || ""}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="TelePhone Nr"
                                name="areaSalesManagerTelePhoneNr"
                                placeholder=""
                                value={
                                  formInputs?.areaSalesManagerTelePhoneNr || ""
                                }
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Email"
                                name="areaSalesManagerTelePhoneNrEmailId"
                                placeholder=""
                                value={
                                  formInputs?.areaSalesManagerTelePhoneNrEmailId ||
                                  ""
                                }
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Carpet Area/Layout"
                                name="areaSalesManagerCarpetArea"
                                placeholder=""
                                value={
                                  formInputs?.areaSalesManagerCarpetArea || ""
                                }
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Square Feet"
                                name="areaSalesManagerSquareFeet"
                                placeholder=""
                                value={
                                  formInputs?.areaSalesManagerSquareFeet || ""
                                }
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="CRedit Limit(RS)"
                                name="areaSalesManagerSquareFeetCreditLimit"
                                placeholder=""
                                value={
                                  formInputs.areaSalesManagerSquareFeetCreditLimit ||
                                  ""
                                }
                                onChange={onInputChange}
                              />
                            </Col>
                          </Row>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Tax Classification**													 */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible13
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility13}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">TC</span>
                        </Col>
                        <Col xs={8} md={9} lg={9}>
                          <span className="headerTitle">
                            Tax Classification
                          </span>
                          <span className="subHeaderTitle">
                            Tax Classification Details
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible13 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="TCS/TDS"
                              placeholder=""
                              data={getTaxClassificationTCSTDS}
                              id="taxClassificationTCSTDS"
                              iconClassName="dropdownIcon"
                              name="taxClassificationTCSTDS"
                              code="taxClassificationTCSTDSCode"
                              description="taxClassificationTCSTDSDesc"
                              setValue={formInputs?.taxClassificationTCSTDS}
                              getvalue={setDropdownData}
                              error={validation?.taxClassificationTCSTDS}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Applicable"
                              name="getTcsTdsApplicabel"
                              placeholder=""
                              value={getTcsTdsApplicabel || ""}
                              // onChange={onInputChange}
                              disabled={true}
                              // required={true}
                              // error={validation.organisationName}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Invoice"
                              name="getTcsTdsInvoice"
                              placeholder=""
                              value={getTcsTdsInvoice || ""}
                              // onChange={onInputChange}
                              disabled={true}
                              // required={true}
                              // error={validation.organisationName}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bill to Party */}

                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible14
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility14}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">BP</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Bill To Party</span>
                          <span className="subHeaderTitle">
                            Bill To Party Details
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible14 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={12}
                            lg={12}
                            className="commTopButtonRightLeftPadding"
                          >
                            <h5 className="bg-table-status bg-table-new-status mt-3 p-3">
                              Bill-to-Party
                            </h5>
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Title text"
                              name="billToPartyTitleText"
                              placeholder=""
                              value={formInputs?.billToPartyTitleText || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Name"
                              name="billToPartyname"
                              placeholder=""
                              value={formInputs?.billToPartyname || ""}
                              onChange={onInputChange}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Street 1"
                              name="billToPartystreet1"
                              placeholder=""
                              value={formInputs?.billToPartystreet1 || ""}
                              onChange={onInputChange}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Street 2"
                              name="billToPartystreet2"
                              placeholder=""
                              value={formInputs?.billToPartystreet2 || ""}
                              onChange={onInputChange}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Street 3"
                              placeholder=""
                              // data={getCountry}
                              id="billToPartystreet3"
                              iconClassName="dropdownIcon"
                              name="billToPartystreet3"
                              value={formInputs?.billToPartystreet3 || ""}
                              onChange={onInputChange}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Search Term"
                              placeholder=""
                              // data={getState}
                              // id="state"
                              iconClassName="dropdownIcon"
                              name="billToPartysearchTerm"
                              value={formInputs?.billToPartysearchTerm || ""}
                              onChange={onInputChange}

                              // getvalue={setDropdownData}
                              // className="dropdownOption"
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Req ID"
                              name="billToPartyReqId"
                              placeholder=""
                              value={formInputs?.billToPartyReqId || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Country"
                              placeholder=""
                              data={getCountry}
                              id="billToPartycountry"
                              iconClassName="dropdownIcon"
                              name="billToPartycountry"
                              code="billToPartycountryCode"
                              description="billToPartycountryDesc"
                              setValue={formInputs.billToPartycountry}
                              getvalue={setDropdownData}
                              required={true}
                              error={validation.billToPartycountry}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="State"
                              placeholder=""
                              data={getState}
                              id="billToPartyState"
                              iconClassName="dropdownIcon"
                              name="billToPartyState"
                              code="billToPartyStateCode"
                              description="billToPartyStateDesc"
                              setValue={formInputs.billToPartyState}
                              getvalue={setDropdownData}
                              required={true}
                              error={validation.billToPartyState}
                            />
                          </Col>                          
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Zip COde"
                              name="billToPartyZipCode"
                              placeholder=""
                              value={formInputs?.billToPartyZipCode || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="City"
                              name="billToPartyCity"
                              placeholder=""
                              value={formInputs.billToPartyCity || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Mobile"
                              name="billToPartyMobile"
                              placeholder=""
                              value={formInputs?.billToPartyMobile || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="TelePhone"
                              name="billToPartyTelePhone"
                              placeholder=""
                              value={formInputs?.billToPartyTelePhone || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Email"
                              name="billToPartyEmail"
                              placeholder=""
                              value={formInputs?.billToPartyEmail || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Row>
                            <Col xs={12} md={5} lg={5}>
                              <h5 className="bg-table-status bg-table-warning-status mt-1">
                                Other Details
                              </h5>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="GSTIN Nr"
                                name="billToPartyGstinNr"
                                placeholder=""
                                value={formInputs?.billToPartyGstinNr || ""}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="PAN Nr"
                                name="billToPartyPanNr"
                                placeholder=""
                                value={formInputs?.billToPartyPanNr || ""}
                                onChange={onInputChange}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12} md={5} lg={5}>
                              <h5 className="bg-table-status bg-table-warning-status mt-1">
                                Payer
                              </h5>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Title text"
                                name="payerToPartyTitleText"
                                placeholder=""
                                value={formInputs?.payerToPartyTitleText || ""}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Name"
                                name="payerToPartyname"
                                placeholder=""
                                value={formInputs?.payerToPartyname || ""}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Street 1"
                                name="payerToPartystreet1"
                                placeholder=""
                                value={formInputs?.payerToPartystreet1 || ""}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Street 2"
                                name="payerToPartystreet2"
                                placeholder=""
                                value={formInputs?.payerToPartystreet2 || ""}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Street 3"
                                placeholder=""
                                // data={getCountry}
                                id="payerToPartystreet3"
                                iconClassName="dropdownIcon"
                                name="payerToPartystreet3"
                                value={formInputs?.payerToPartystreet3 || ""}
                                onChange={onInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Search Term"
                                placeholder=""
                                // data={getState}
                                // id="state"
                                iconClassName="dropdownIcon"
                                name="payerToPartysearchTerm"
                                value={formInputs?.payerToPartysearchTerm || ""}
                                onChange={onInputChange}

                                // getvalue={setDropdownData}
                                // className="dropdownOption"
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Req ID"
                                name="payerToPartyReqId"
                                placeholder=""
                                value={formInputs?.payerToPartysearchTerm || ""}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Country"
                                placeholder=""
                                data={getCountry}
                                id="payerToPartycountry"
                                iconClassName="dropdownIcon"
                                name="payerToPartycountry"
                                code="payerToPartycountryCode"
                                description="payerToPartycountryDesc"
                                setValue={formInputs?.payerToPartycountry}
                                getvalue={setDropdownData}
                                required={true}
                                error={validation?.payerToPartycountry}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="State"
                                placeholder=""
                                data={getState}
                                id="payerToPartyState"
                                iconClassName="dropdownIcon"
                                name="payerToPartyState"
                                code="payerToPartyStateCode"
                                description="payerToPartyStateDesc"
                                setValue={formInputs.payerToPartyState}
                                getvalue={setDropdownData}
                                required={true}
                                error={validation.payerToPartyState}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Zip COde"
                                name="payerToPartyZipCode"
                                placeholder=""
                                value={formInputs?.payerToPartyZipCode || ""}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="City"
                                name="payerToPartyCity"
                                placeholder=""
                                value={formInputs.payerToPartyCity || ""}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Mobile"
                                name="payerToPartyMobile"
                                placeholder=""
                                value={formInputs?.payerToPartyMobile || ""}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="TelePhone"
                                name="payerToPartyTelePhone"
                                placeholder=""
                                value={formInputs?.payerToPartyTelePhone || ""}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Email"
                                name="payerToPartyEmail"
                                placeholder=""
                                value={formInputs?.payerToPartyEmail || ""}
                                onChange={onInputChange}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12} md={5} lg={5}>
                              <h5 className="bg-table-status bg-table-warning-status mt-1">
                                Other Details
                              </h5>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="GSTIN Nr"
                                name="payerToPartyGstinNr"
                                placeholder=""
                                value={formInputs?.payerToPartyGstinNr || ""}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="PAN Nr"
                                name="payerToPartyPanNr"
                                placeholder=""
                                value={formInputs?.payerToPartyPanNr || ""}
                                onChange={onInputChange}
                              />
                            </Col>
                          </Row>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/*  Approval*												 */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible15
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility15}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">A</span>
                        </Col>
                        <Col xs={8} md={9} lg={9}>
                          <span className="headerTitle">Approval</span>
                          <span className="subHeaderTitle">
                            Approval Details
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible15 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          {/* requestor */}
                          <Row>
                            <Col xs={12} md={5} lg={5}>
                              <h5 className="bg-table-status bg-table-warning-status mt-1">
                                Requestor
                              </h5>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Prepared by"
                                name="requestorPreparedby"
                                placeholder=""
                                value={formInputs?.requestorPreparedby || ""}
                                // onChange={onInputChange}
                                disabled={true}
                                // required={true}
                                // error={validation.organisationName}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Date"
                                name="requestorDate"
                                type="date"
                                placeholder=""
                                value={formInputs?.requestorDate || ""}
                                // onChange={onInputChange}
                                disabled={true}
                                // required={true}
                                // error={validation.organisationName}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Signature"
                                name="requestorSignature"
                                placeholder=""
                                value={formInputs?.requestorSignature || ""}
                                // onChange={onInputChange}
                                disabled={true}
                                // required={true}
                                // error={validation.organisationName}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Mail Approval"
                                name="requestorMailApproval"
                                placeholder=""
                                value={formInputs?.requestorMailApproval || ""}
                                // onChange={onInputChange}
                                disabled={true}
                                // required={true}
                                // error={validation.organisationName}
                              />
                            </Col>
                          </Row>
                          {/* channel/Sales Head */}
                          <Row>
                            <Col xs={12} md={5} lg={5}>
                              <h5 className="bg-table-status bg-table-warning-status mt-1">
                                Channel/ Sales Head
                              </h5>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Approvde by"
                                name="channelApprovdeBy"
                                placeholder=""
                                value={formInputs?.channelApprovdeBy || ""}
                                // onChange={onInputChange}
                                disabled={true}
                                // required={true}
                                // error={validation.organisationName}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Date"
                                name="channelDate"
                                type="date"
                                placeholder=""
                                value={formInputs?.channelDate || ""}
                                // onChange={onInputChange}
                                disabled={true}
                                // required={true}
                                // error={validation.organisationName}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Signature"
                                name="channelSignature"
                                placeholder=""
                                value={formInputs?.channelSignature || ""}
                                // onChange={onInputChange}
                                disabled={true}
                                // required={true}
                                // error={validation.organisationName}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Mail Approval"
                                name="channelMailApproval"
                                placeholder=""
                                value={formInputs?.channelMailApproval || ""}
                                // onChange={onInputChange}
                                disabled={true}
                                // required={true}
                                // error={validation.organisationName}
                              />
                            </Col>
                          </Row>
                          {/* Head Commercial			 */}
                          <Row>
                            <Col xs={12} md={5} lg={5}>
                              <h5 className="bg-table-status bg-table-warning-status mt-1">
                                Head Commercial
                              </h5>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Approvde by"
                                name="headCommercialApprovdeBy"
                                placeholder=""
                                value={
                                  formInputs?.headCommercialApprovdeBy || ""
                                }
                                // onChange={onInputChange}
                                disabled={true}
                                // required={true}
                                // error={validation.organisationName}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Date"
                                name="headCommercialDate"
                                type="date"
                                placeholder=""
                                value={formInputs?.headCommercialDate || ""}
                                // onChange={onInputChange}
                                disabled={true}
                                // required={true}
                                // error={validation.organisationName}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Signature"
                                name="headCommercialSignature"
                                placeholder=""
                                value={
                                  formInputs?.headCommercialSignature || ""
                                }
                                // onChange={onInputChange}
                                disabled={true}
                                // required={true}
                                // error={validation.organisationName}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Mail Approval"
                                name="headCommercialMailApproval"
                                placeholder=""
                                value={
                                  formInputs?.headCommercialMailApproval || ""
                                }
                                // onChange={onInputChange}
                                disabled={true}
                                // required={true}
                                // error={validation.organisationName}
                              />
                            </Col>
                          </Row>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={CustomerConstants.CUSTOMER_V3_CUSTOMER_LIST}
      />

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default CustomerSelfRegistrationV4;
